(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["equicore-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('equicore-review-carousel')) {
  customElements.define('equicore-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.track = this.querySelector('.equicore-reviews-track');
      this.pagination = this.querySelector('.equicore-reviews-pagination');
      this.cards = Array.from(this.track.children);
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplay = this.dataset.autoplay !== 'false';
      this.motionOverride = false;
      this.autoplayDelay = Number(this.dataset.autoplayDelay) || 6000;
      this.visible = false;

      this.buildPagination();

      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.updatePagination());
      }, { ...options, passive: true });

      this.track.addEventListener('pointerdown', () => clearTimeout(this.autoplayTimer), options);
      this.track.addEventListener('pointerup', () => this.startAutoplay(), options);
      this.track.addEventListener('pointercancel', () => this.startAutoplay(), options);
      this.pagination.addEventListener('click', event => {
        if (!event.target.closest('.equicore-reviews-play')) this.startAutoplay();
      }, options);

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.buildPagination();
          this.startAutoplay();
        }, 120);
      }, options);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }, options);

      this.motion.addEventListener('change', () => {
        if (this.motion.matches && !this.motionOverride) this.stopAutoplay();
        else this.startAutoplay();
      }, options);

      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0]?.isIntersecting ?? false;
        if (this.visible) this.startAutoplay();
        else this.stopAutoplay();
      }, { threshold: 0.2 });
      this.observer.observe(this);

      this.addEventListener('shopify:block:select', event => {
        this.autoplay = false;
        this.stopAutoplay();
        const card = event.target.closest('.equicore-testimonials__card');
        const index = this.cards.indexOf(card);
        if (index > -1) this.scrollToCard(index, false);
      }, options);
    }

    buildPagination() {
      this.pagination.innerHTML = '';

      if (this.cards.length < 2) {
        this.pagination.hidden = true;
        this.positions = [];
        return;
      }

      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const base = this.cards[0].offsetLeft;
      this.positions = [];

      this.cards.forEach((card, index) => {
        const left = Math.max(0, Math.min(max, card.offsetLeft - base));
        if (!this.positions.some(item => Math.abs(item.left - left) < 2)) {
          this.positions.push({ left, index });
        }
      });

      this.pagination.hidden = this.positions.length < 2;
      const playButton = document.createElement('button');
      playButton.type = 'button';
      playButton.className = 'equicore-reviews-play';
      playButton.addEventListener('click', () => {
        this.autoplay = !this.autoplay;
        if (this.autoplay) {
          this.motionOverride = true;
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }, { signal: this.abort.signal });
      this.pagination.appendChild(playButton);

      this.positions.forEach((position, dotIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'equicore-reviews-dot';
        button.setAttribute('aria-label', 'Go to review ' + (position.index + 1));
        button.addEventListener('click', () => this.scrollToPosition(dotIndex, true), { signal: this.abort.signal });
        this.pagination.appendChild(button);
      });

      this.updatePagination();
      this.updateAutoplayControl();
    }

    activePosition() {
      if (!this.positions?.length) return 0;
      let active = 0;
      this.positions.forEach((position, index) => {
        if (Math.abs(position.left - this.track.scrollLeft) < Math.abs(this.positions[active].left - this.track.scrollLeft)) {
          active = index;
        }
      });
      return active;
    }

    updatePagination() {
      if (!this.positions?.length) return;
      const active = this.activePosition();
      Array.from(this.pagination.querySelectorAll('.equicore-reviews-dot')).forEach((button, index) => {
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    updateAutoplayControl() {
      const button = this.pagination.querySelector('.equicore-reviews-play');
      if (!button) return;
      const isPlaying = this.autoplay && this.visible && !document.hidden && (!this.motion.matches || this.motionOverride);
      button.classList.toggle('is-playing', isPlaying);
      button.setAttribute('aria-label', isPlaying ? 'Pause reviews' : 'Play reviews automatically');
      button.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
    }

    scrollToPosition(index, smooth) {
      const position = this.positions[index];
      if (!position) return;
      this.track.scrollTo({
        left: position.left,
        behavior: smooth && !this.motion.matches ? 'smooth' : 'instant'
      });
    }

    scrollToCard(index, smooth) {
      const target = Math.max(0, Math.min(
        this.track.scrollWidth - this.track.clientWidth,
        this.cards[index].offsetLeft - this.cards[0].offsetLeft
      ));
      let closest = 0;
      this.positions.forEach((position, i) => {
        if (Math.abs(position.left - target) < Math.abs(this.positions[closest].left - target)) closest = i;
      });
      this.scrollToPosition(closest, smooth);
    }

    startAutoplay() {
      clearTimeout(this.autoplayTimer);
      this.updateAutoplayControl();
      if (!this.autoplay || (this.motion.matches && !this.motionOverride) || document.hidden || !this.visible || this.positions.length < 2) return;

      this.autoplayTimer = setTimeout(() => {
        const next = (this.activePosition() + 1) % this.positions.length;
        this.scrollToPosition(next, true);
        this.startAutoplay();
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      clearTimeout(this.autoplayTimer);
      this.updateAutoplayControl();
    }

    disconnectedCallback() {
      this.stopAutoplay();
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.scrollFrame);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
